import axios, { AxiosRequestConfig } from 'axios';

export class BaseService {
    private baseURL = process.env.REACT_APP_API_BASE_URL;

    async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        const response = await axios.get<T>(`${this.baseURL}${url}`, config);
        return response.data;
    }

    async post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
        const response = await axios.post<T>(`${this.baseURL}${url}`, data, config);
        return response.data;
    }
}
